module.exports = __webpack_public_path__ + "static/img/silver 3.da1598e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/silver 3.png
// module id = twVa
// module chunks = 35